import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import container from 'src/container';
import { UserThunks } from 'src/state/thunks';
import { unregisterWebPushToken } from 'src/services/webPush.service';

const { authService, munduClient } = container.cradle;

const withTimeout = (promise: Promise<unknown>, timeoutMs: number) =>
    Promise.race([
        promise,
        new Promise(resolve => setTimeout(resolve, timeoutMs)),
    ]);

export const useLogout = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    return useCallback(
        async (redirectPath = '/login') => {
            await withTimeout(
                Promise.all([
                    munduClient
                        .unregisterPushToken('web')
                        .catch(() => undefined),
                    unregisterWebPushToken().catch(() => undefined),
                ]),
                1200,
            );

            authService.logout();
            dispatch(UserThunks.logout());
            if (redirectPath) {
                history.replace(redirectPath);
            }
        },
        [dispatch, history],
    );
};
